import { Filter } from './Filter';
import { computed, observable, action } from 'mobx';
import { FilterQuery } from './FilterQuery';
import { Product } from './Product';
import { FilterQueryLogic, IFilterSets } from '../../views/product-filters/IProductFilters';
import { createFilter } from '../services/FilterSetFactory';

export interface IFilterCheckbox {
    label: string;
    key: string;
    category: string;
    id: string;
}

export interface IFilterItem {
    keyType: string;
    keyName: string;
}

export class FilterSet {
    @observable public filters: Filter[] = [];
    @observable public filterQueries: FilterQuery[];
    @observable public logic: FilterQueryLogic;
    @observable public label: string;
    @observable public key: string;
    @observable public isOpen: boolean = false;

    constructor(filterSetJson: IFilterSets) {
        this.logic = filterSetJson.logic;
        this.label = filterSetJson.label;
        this.key = filterSetJson.key;

        this.filterQueries = filterSetJson.query.map(
            filterQueryJson => new FilterQuery(filterQueryJson)
        );

        this.filters = filterSetJson.items
            ? filterSetJson.items.map(filterItemJson => createFilter(filterItemJson, filterSetJson))
            : [];
    }

    @action public setApplicableFilters(filtersCollection: Filter[]): void {
        this.filters = filtersCollection;
    }

    @computed get activeFilters(): Filter[] {
        return this.filters.filter((_filter: Filter) => _filter.active);
    }

    @action public setOpenState = (newState: boolean) => {
        this.isOpen = newState;
    };

    @action public toggleOpenState = () => {
        this.isOpen = !this.isOpen;
    };

    @action public clearAllFilters = () => {
        this.activeFilters.forEach(filter => filter.setActiveState(false));
    };

    public passes(product: Product): boolean {
        const extractedValues = this.filterQueries.reduce(
            (values: string[], currentQuery: FilterQuery) => {
                return values.concat(currentQuery.extract(product));
            },
            []
        );

        return this.activeFilters.some(filter => filter.passes(extractedValues));
    }
}
